import {
  Checkbox,
  FormControlLabel,
  IconButton,
  TextField,
} from "@mui/material";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import { useMemo, useState } from "react";
import RecurrenceDialog from "./RecurrenceDialog";
import dayjs from "dayjs";
import { pluralise } from "../../../../helpers/text";
import HelpLink from "../../../help/HelpLink";

const RecurringTasksContainer = ({
  frequency,
  isRecurring,
  setRecurring,
  hasDeadline,
  setHasDeadline,
  setDeadline,
  setFrequency,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const recurringLabelText = useMemo(() => {
    if (isRecurring && frequency) {
      const { intervalCount, intervalDateType, startIntervalOnCompletion } =
        frequency;
      if (startIntervalOnCompletion) {
        return `${intervalCount} ${pluralise(intervalDateType, intervalCount)} after completion`;
      }
      return `Every ${intervalCount === 1 ? "" : `${intervalCount} `}${pluralise(intervalDateType, intervalCount)}`;
    }
    return "Does not repeat";
  }, [isRecurring, frequency]);

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setRecurring(checked);

    if (checked) {
      // Open the dialog when enabling recurrence
      setDialogOpen(true);
      // Set a default frequency
      setFrequency({
        startDate: dayjs().startOf("day").valueOf(),
        intervalCount: 1,
        intervalDateType: "week",
      });
    } else {
      setFrequency(undefined);
    }

    if (hasDeadline) {
      setHasDeadline(false);
      setDeadline(undefined);
    }
  };

  return (
    <div className="recurring-tasks-container">
      <div style={{ display: "flex", alignItems: "center" }}>
        <HelpLink
          to="/about/features/tasks/recurring-tasks"
          size="small"
          sx={{ ml: -1.5 }}
        />
        <FormControlLabel
          label=""
          control={
            <Checkbox
              label="Recurring"
              checked={!!isRecurring}
              onChange={handleCheckboxChange}
            />
          }
        />
      </div>
      <TextField
        label="Repeats"
        variant="outlined"
        disabled={!isRecurring}
        onClick={() => {
          if (!isRecurring) return;
          setDialogOpen(true);
        }}
        value={recurringLabelText}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <IconButton
              disabled={!isRecurring}
              className={"recurring-tasks-container_icon-button"}
            >
              <EventRepeatIcon />
            </IconButton>
          ),
        }}
      />
      <RecurrenceDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        frequency={frequency}
        setFrequency={setFrequency}
      />
    </div>
  );
};

export default RecurringTasksContainer;
